import React, { useState, useCallback, useEffect } from 'react';
import CloseIcon from "../../assets/images/close.png";
import { connect } from "react-redux";
import { compose } from "redux";
import { Disable } from 'react-disable';
import debounce from "lodash/debounce";

import {
    updateComplianceStandard,
    addProcedureToCompliance,
    addAttachmentToProcedure,
    editComplianceProcedure,
    getComplianceProcedures
} from "../../store/actions/complianceActions";

import Select from 'react-select';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};

const ComplianceOverlay = ({
    close,
    compliance,
    edit,
    updateComplianceFN,
    compliance_redux,
    addProcedureToComplianceFN,
    addAttachmentToProcedureFN,
    editComplianceProcedureFN,
    getComplianceProceduresFN
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const compliance_categories = [
        { value: 'ISO', label: 'ISO', color: "#0081A7" },
        { value: 'NIST', label: 'NIST', color: "#00AFB9" },
        { value: 'GDPR', label: 'GDPR', color: "#FED9B7" },
        { value: 'PCI-DSS', label: 'PCI-DSS', color: "#D6606E" },
        { value: 'HIPAA', label: 'HIPAA', color: "#BB133E" },
    ];

    const compliance_colors = [
        { value: '#FF5733', label: 'Red Orange', color: "#FF5733" },
        { value: '#33FF57', label: 'Green', color: "#33FF57" },
        { value: '#3357FF', label: 'Blue', color: "#3357FF" },
        { value: '#F1C40F', label: 'Yellow', color: "#F1C40F" },
        { value: '#8E44AD', label: 'Purple', color: "#8E44AD" },
        { value: '#E67E22', label: 'Carrot', color: "#E67E22" },
        { value: '#2ECC71', label: 'Emerald', color: "#2ECC71" },
        { value: '#3498DB', label: 'Peter River', color: "#3498DB" },
        { value: '#9B59B6', label: 'Amethyst', color: "#9B59B6" },
        { value: '#34495E', label: 'Wet Asphalt', color: "#34495E" }
    ];

    const [policies, setPolicies] = useState([]);
    const [formControlState, setFormControlState] = useState([]);
    const [currentPolicy, setCurrentPolicy] = useState(null);
    const fileInputRef = React.useRef(null);

    const [formState, setFormState] = useState({
        name: compliance ? compliance.name : '',
        category: compliance ? compliance.category : '',
        description: compliance ? compliance.description : '',
        color: compliance ? compliance.color : '',
        comments: '',
    });

    ////console.log("compliance ", compliance)

    useEffect(() => {
        if (compliance) {
            ////console.log("compliance ", compliance)
            setPolicies([]);
            getComplianceProceduresFN(compliance.compliance_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (compliance) {
            setPolicies(compliance.policies);
        }
    }, [compliance]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && currentPolicy) {
            addAttachmentToProcedureFN(compliance.compliance_id, currentPolicy.id, file);
        }
    };

    const handleAttachmentClick = (policy) => {
        setCurrentPolicy(policy);
        if (policy.attachment) {
            window.open(policy.attachment, '_blank');
        } else {
            fileInputRef.current.click();
        }
    };

    const handleChange = (data) => {
        setFormState(data);
        updateServerData(data, compliance.compliance_id);
    };

    const updateServerData = useCallback(
        debounce(async (data, compliance_id) => {
            ////////console.log("Debounced update triggered for compliance:", compliance_id, data);
            setIsLoading(true);
            try {
                await updateComplianceFN(compliance_id, data); // Await the action to ensure completion
            } catch (error) {
                console.error("Error updating compliance standard:", error);
            } finally {
                setIsLoading(false); // Ensure isLoading is reset whether successful or not
            }
        }, 1500),
        []
    );

    const handleChangePolicy = (data, policy_id) => {
        const updatedPolicy = data.find(policy => policy.id === policy_id);
        updateServerData2(updatedPolicy, compliance.compliance_id, policy_id);
    };

    const updateServerData2 = useCallback(
        debounce((data, compliance_id, policy_id) => {
            setIsLoading(true);
            editComplianceProcedureFN(compliance_id, policy_id, data);
        }, 1500),
        []
    );

    useEffect(() => {
        if (compliance_redux) {
            const this_compliance = compliance_redux.find(
                complianceItem => complianceItem.id === compliance.compliance_id
            );
            setFormControlState([]);
            this_compliance &&
                this_compliance.policies.map(policy => {
                    const newPolicy = { ...policy };
                    setFormControlState(prevState => [...prevState, newPolicy]);
                });
            setIsLoading(false);
        }
    }, [compliance_redux, compliance?.compliance_id]);

    return (
        <Disable disabled={isLoading}>
            <div className="p-6 bg-white rounded-2xl border border-gray-200 shadow-xl">
                <div className="flex justify-between items-center mb-5">
                    <div>
                        <h1 className="text-[16px] font-semibold text-gray-900">
                            {edit ? "Edit Compliance" : "New Compliance"}
                        </h1>
                        <p className="text-[12px] text-gray-500 mt-0.5">
                            Define the compliance standard details.
                        </p>
                    </div>

                    <button
                        className="p-2 rounded-lg hover:bg-gray-100 active:bg-gray-200 transition"
                        onClick={close}
                        title="Close"
                        type="button"
                    >
                        <img src={CloseIcon} alt="Close" className="w-6 h-6" />
                    </button>
                </div>

                {/* Inputs */}
                <div className="space-y-4">
                    <div>
                        <label className="text-[12px] font-medium text-gray-700">Name</label>
                        <input
                            type="text"
                            placeholder="e.g. ISO 27001"
                            className="mt-1 w-full h-10 px-3 rounded-xl border border-gray-200 bg-gray-100/60 focus:bg-white focus:border-gray-300 focus:outline-none"
                            value={formState.name}
                            onChange={(e) => handleChange({ ...formState, name: e.target.value })}
                        />
                    </div>

                    <div>
                        <label className="text-[12px] font-medium text-gray-700">Description</label>
                        <textarea
                            placeholder="Short description..."
                            className="mt-1 w-full min-h-[110px] px-3 py-2 rounded-xl border border-gray-200 bg-gray-100/60 focus:bg-white focus:border-gray-300 focus:outline-none resize-none"
                            value={formState.description}
                            onChange={(e) => handleChange({ ...formState, description: e.target.value })}
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div className="md:col-span-2">
                            <label className="text-[12px] font-medium text-gray-700">Category</label>
                            <div className="mt-1">
                                <Select
                                    options={compliance_categories}
                                    placeholder="Select category"
                                    onChange={(e) => handleChange({ ...formState, category: e.value })}
                                    styles={customStyles}
                                    value={compliance_categories.find((cat) => cat.value === formState.category)}
                                />
                            </div>
                        </div>

                        <div>
                            <label className="text-[12px] font-medium text-gray-700">Color</label>
                            <div className="mt-1">
                                <Select
                                    options={compliance_colors}
                                    placeholder="Select color"
                                    onChange={(e) => handleChange({ ...formState, color: e.value })}
                                    styles={customStyles}
                                    value={compliance_colors.find((c) => c.value === formState.color)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer actions (optional if you have save button elsewhere) */}
                {/* <div className="mt-6 flex justify-end gap-2">
        <button className="h-10 px-4 rounded-xl border border-gray-200 hover:bg-gray-50" onClick={close}>Cancel</button>
        <button className="h-10 px-5 rounded-xl bg-[#0B0B0F] text-white hover:opacity-90">Save</button>
      </div> */}
            </div>
        </Disable>
    );

};

const mapStateToProps = (state) => {
    return {
        compliance_redux: state.compliance.policies,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateComplianceFN: (compliance_id, data) => dispatch(updateComplianceStandard(compliance_id, data)),
        addProcedureToComplianceFN: (compliance_id) => dispatch(addProcedureToCompliance(compliance_id)),
        addAttachmentToProcedureFN: (compliance_id, policy_id, file) => dispatch(addAttachmentToProcedure(compliance_id, policy_id, file)),
        editComplianceProcedureFN: (compliance_id, policy_id, policy) => dispatch(editComplianceProcedure(compliance_id, policy_id, policy)),
        getComplianceProceduresFN: (compliance_id) => dispatch(getComplianceProcedures(compliance_id)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceOverlay);